import { useContext, useMemo, useState } from 'react'
import dayjs from 'dayjs'
import useLocalStorage from 'hooks/useLocalStorage'
import useUrlParams from 'hooks/useUrlParams'
import useApiParams from 'hooks/useApiParams'
import DrupalContext from 'contexts/DrupalContext'
import { getDepartmentList, getEntityList } from 'helpers/params'

const useDefaultParams = () => {
  const { urlParams, updateUrlParams } = useUrlParams()
  const { updateApiParams } = useApiParams()
  const drupal = useContext(DrupalContext)
  const [storage] = useLocalStorage(drupal.niche, '')
  const [urlParamsChanged, setUrlParamsChanged] = useState(false)
  const defaultHits = 25

  useMemo(() => {
    const searcher = drupal.niche || urlParams.searcher

    if (!urlParams.hits && searcher) {
      updateUrlParams({ hits: defaultHits })
    }

    if (searcher === 'event' && !urlParams.date_from) {
      const today = dayjs().format('YYYY-MM-DD')
      updateUrlParams({ date_from: today, hits: defaultHits })
    }

    if (drupal.niche === 'local_page') {
      if (typeof storage === 'object' && JSON.stringify(urlParams) !== JSON.stringify(storage.urlParams)) {
        setUrlParamsChanged(true)
      } else {
        setUrlParamsChanged(false)
      }
      /**
       * We need to check with a diff against localStorage for linked urls.
       *
       * If a user recives a link with different urlParameters then what they have saved
       * in localStorage, we reset localStorage with the new parameters.
       */
        if (storage.urlParams && Object.keys(urlParams).length && (JSON.stringify(urlParams) !== JSON.stringify(storage.urlParams)) ) {
          storage.urlParams = urlParams
          storage.apiParams = getDepartmentList(urlParams)
          storage.entityParams = getEntityList(urlParams)
        }
        updateUrlParams(storage.urlParams)
        updateApiParams(storage.apiParams, storage.entityParams)
    }
  }, [drupal.niche, urlParams.searcher])

  return {
    urlParamsChanged,
  }
}

export default useDefaultParams
